<template>
    <jet-form-section @submitted="updateNotifications">
        <template #title>
            Notificaties
        </template>

        <template #description>
            Kies welke notificaties je wenst te krijgen
        </template>

        <template #form>
            <div class="col-span-6 sm:col-span-4">
                <template v-for="(notification, key) in notifications">
                    <jet-checkbox :value="key" v-model:checked="form.notifications"/><span class="ml-2 text-sm text-gray-600">{{ notification }}</span><br>
                </template>
            </div>
        </template>

        <template #actions>
            <jet-action-message :on="form.recentlySuccessful" class="mr-3">
                Saved.
            </jet-action-message>

            <jet-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                Save
            </jet-button>
        </template>
    </jet-form-section>
</template>

<script>
import JetActionMessage from '@/Jetstream/ActionMessage.vue'
import JetButton from '@/Jetstream/Button.vue'
import JetFormSection from '@/Jetstream/FormSection.vue'
import JetInput from '@/Jetstream/Input.vue'
import JetCheckbox from '@/Jetstream/Checkbox.vue'
import JetInputError from '@/Jetstream/InputError.vue'
import JetLabel from '@/Jetstream/Label.vue'

export default {
    components: {
        JetActionMessage,
        JetButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetCheckbox
    },
    props:[
        'notifications',
        'subscribed'
    ],

    data() {
        return {
            form: this.$inertia.form({
                notifications: this.subscribed
            }),
        }
    },
    methods: {
        updateNotifications() {
            this.form.put(route('settings.notifications'), {
                errorBag: 'notifications',
                preserveScroll: true,
            })
        },
    },
}
</script>
